module.exports = require("leaflet-moving-rotated-marker");


//////////////////
// WEBPACK FOOTER
// external "leaflet-moving-rotated-marker"
// module id = 5
// module chunks = 0